import { assertProd } from 'utils/assert-prod'

export type ContactUsData = {
  name: string
  email: string
  subject: string
  message: string
}

export const sendContactInfoToAdmin = async (data: ContactUsData) => {
  const { name, email, subject, message } = data

  const botToken = process.env.NEXT_PUBLIC_TELEGRAM_BOT_TOKEN
  const chatId = process.env.NEXT_PUBLIC_TELEGRAM_CHAT_ID

  if (!botToken || !chatId) {
    assertProd(
      false,
      `Contact info not sent to admin for user ${email} - missing environment variables (TELEGRAM_BOT_TOKEN or TELEGRAM_CHAT_ID)`
    )
    return
  }

  const text = `<b>New Contact Form Submission</b>\n<b>Name:</b> <code>${name}</code>\n<b>Email:</b> <code>${email}</code>\n<b>Subject:</b> <code>${subject}</code>\n<b>Message:</b>\n<pre>${message}</pre>\n<i>Please respond to this inquiry as soon as possible.</i>`

  const response = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      chat_id: chatId,
      text,
      parse_mode: 'HTML',
    }),
  })

  if (!response.ok) {
    throw new Error('Failed to send contact info to admin')
  }

  return response.json()
}
